module.exports = __webpack_public_path__ + "img/sq5m_feature_01.d882931a.jpg";